/**
 * Angular imports.
 */
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnDestroy } from '@angular/core';

/**
 * Service imports.
 */
import { PostApiService } from './../../dataservices/post-api.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { MultiLangService } from '../../dataservices/master-service/multi-lang.service';
import { JwtDecodeService } from '../../dataservices/jwt-decode.service';

/**
 * Model imports.
 */
import { ModalDirective } from 'ngx-bootstrap/modal';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';

/**
 * product bookmark
 */
@Component({
  selector: 'app-product-bookmark',
  templateUrl: './product-bookmark.component.html',
  styleUrls: ['./product-bookmark.component.scss']
})
export class ProductBookmarkComponent implements OnInit, OnDestroy {
  @ViewChild('autoShownModal') autoShownModal: ModalDirective;
  @Output() resetBookmark = new EventEmitter();
  @Input() bookmarkObj;
  public success = true;
  public isErrorModalShown = false;
  public error_msg: string;

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * Necessary instance.
   */
  constructor(
    private jwtSer: JwtDecodeService,
    private postSer: PostApiService,
    public funCollectionService: FunCollectionService,
    public mls: MultiLangService) {
  }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.subscriptions.add(this.postSer.setBookmark(this.bookmarkObj.product_id, this.bookmarkObj.product_type).subscribe(resData => {
      this.jwtSer.decodeData(resData).then(data => {
        // alert()
        if (data['status'] === 1) {
          if (data['data'].is_bookmark === 1) {
            this.funCollectionService.showSuccess(this.mls.you_have_bookmarked_successfully, 'Success');
          } else if (data['data'].is_bookmark === 0) {
            this.funCollectionService.showSuccess(this.mls.you_have_unbookmarked_successfully, 'Success');
          }

          this.resetBookmark.emit(data['data'].is_bookmark);

        } else if (data['status'] === 9) {
          this.funCollectionService.logout();
        } else {
          // this.resetBookmark.emit(0);
          this.isErrorModalShown = true;
          //  this.error_msg=data['msg'];
          this.ErrorHandler(data['msg']);
        }
      });
    },
    () => {
      this.resetBookmark.emit('failed');
      this.funCollectionService.showError(this.mls.oops_something_went_wrong_please_try_again, 'Error');
    },
    () => {
      // No Code
    }));

  }

  /**
   * reset Error Modal
   */
  resetErrorModal(): void {
    this.isErrorModalShown = false;
    this.resetBookmark.emit('error');

  }

  /**
   * Error Handler
   */
  ErrorHandler(Err_msg): boolean {
    this.isErrorModalShown = true;
    this.error_msg = Err_msg;
    return false;
  }

  /**
   * http Error Handler
   */
  httpErrorHandeler(err): boolean {
    if (err.error.code == 2000) {
      // console.log(err.error.error.msg);
      this.ErrorHandler(err.error.error.msg);
      return false;
    } else if (err.error.error.code == 1002) {
      // this.ErrorHandler(err.error.error.msg);
      this.funCollectionService.logout();
    } else {
      this.ErrorHandler(err.error.error.msg);
      return false;
    }
  }

  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
